import axios, {AxiosRequestConfig} from "axios";
import {action, observable} from "mobx";

import {EAIClient} from "Services/EAIClient";
import {appStore} from "Stores/index";

class TrustedTokenStore {
    eaiClient = new EAIClient();

    axConfig: AxiosRequestConfig = {
        withCredentials: true,
    };

    ax = axios.create(this.axConfig);

    @observable
    sentinelURL: string;

    @action
    async getTrustedToken(){
        if(this.sentinelURL){
            this.ax
                .head(this.sentinelURL)
                .catch(async () => (this.sentinelURL = await this.getURL()));
        } else {
            this.sentinelURL = await this.getURL();
        }
    }

    @action
    async getConnectedAppJwt(){
        try {
            return await this.eaiClient.getConnectedAppToken();
        } catch (e) {
            appStore.addError(e);
        }
    }

    async getURL(){
        return await this.eaiClient
            .getTrustedTokenUrl()
            .then(res => {
                return this.ax
                    .head(res)
                    .then(r => {
                        return r.request.responseURL;
                    })
                    .catch(e => console.log(e));
            })
            .catch(e => console.log(e));
    }
}

const trustedTokenStore = new TrustedTokenStore();

export default trustedTokenStore;
export { TrustedTokenStore };
